import RequestAbstract from "./RequestAbstract";

export default class AnketaQuestionnaireStat extends RequestAbstract {
    get link() {
        return this.links.anketaQuestionnaireStat;
    }

    async getClientAnketa(id) {
        const arr = [
            { field: "clientId", op: "=", value: +id },
        ];

        return this.getAllFiltered([arr]);
    }

    async updateAnswer(info) {
        const res = await this.post(this.link + "/update-by-ids", info);
        return res;
    }


}
